// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterIncomeVerificationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AcceptIncomeVerificationTermsWebApiRequestDto,
  AcceptIncomeVerificationTermsWebApiResponseDto,
  CompletePlaidLinkRequestDto,
  CreateLinkTokenRequestDto,
  CreateLinkTokenResponseDto,
  DeclineIncomeVerificationWebApiRequestDto,
  GetDeclineReasonsWebApiResponseDto,
  GetIncomeVerificationTermsWebApiResponseDto,
  ShareReportRequestDto,
  WebGetIncomeInsightsResponseDto,
  WebGetIncomeVerificationReportStatusResponseDto,
  WebGetRequestedApplicationIdsResponseDto,
  WebGetVerifiedIncomeRequestAndReportStatusResponseDto,
} from '../..';

interface GetVerifiedIncomeRequestAndReportStatusParams {
  applicationId: string;
}

export const CappsRenterIncomeVerificationWebApiHandler_acceptTerms_Path =
  '/api/web/renter/v1/incomeVerification/acceptTerms';

export const CappsRenterIncomeVerificationWebApiHandler_acceptTerms = (
  postData: AcceptIncomeVerificationTermsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    AcceptIncomeVerificationTermsWebApiRequestDto,
    AcceptIncomeVerificationTermsWebApiResponseDto
  >(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_acceptTerms_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_completePlaidLink_Path =
  '/api/web/renter/v1/incomeVerification/completePlaidLink';

export const CappsRenterIncomeVerificationWebApiHandler_completePlaidLink = (
  postData: CompletePlaidLinkRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CompletePlaidLinkRequestDto, void>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_completePlaidLink_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_createLinkToken_Path =
  '/api/web/renter/v1/incomeVerification/createLinkToken';

export const CappsRenterIncomeVerificationWebApiHandler_createLinkToken = (
  postData: CreateLinkTokenRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateLinkTokenRequestDto, CreateLinkTokenResponseDto>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_createLinkToken_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification_Path =
  '/api/web/renter/v1/incomeVerification/declineIncomeVerification';

export const CappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification = (
  postData: DeclineIncomeVerificationWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeclineIncomeVerificationWebApiRequestDto, void>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_declineIncomeVerification_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_deleteReport_Path =
  '/api/web/renter/v1/incomeVerification/deleteReport';

export const CappsRenterIncomeVerificationWebApiHandler_deleteReport = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_deleteReport_Path,
      method: 'POST',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_Path =
  '/api/web/renter/v1/incomeVerification/getDeclineReasons';

export const CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetDeclineReasonsWebApiResponseDto>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_getDeclineReasons_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_Path =
  '/api/web/renter/v1/incomeVerification/getIncomeVerificationReportStatus';

export const CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus = (client = getClient()) => {
  return httpFrontEndRequest<never, never, WebGetIncomeVerificationReportStatusResponseDto>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_Path =
  '/api/web/renter/v1/incomeVerification/getRecentVerifiedIncomeReport';

export const CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport = (client = getClient()) => {
  return httpFrontEndRequest<never, never, WebGetIncomeInsightsResponseDto>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_getRecentVerifiedIncomeReport_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_Path =
  '/api/web/renter/v1/incomeVerification/getRequestedApplicationIds';

export const CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds = (client = getClient()) => {
  return httpFrontEndRequest<never, never, WebGetRequestedApplicationIdsResponseDto>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_getRequestedApplicationIds_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_getTerms_Path =
  '/api/web/renter/v1/incomeVerification/getTerms';

export const CappsRenterIncomeVerificationWebApiHandler_getTerms = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetIncomeVerificationTermsWebApiResponseDto>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_getTerms_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_Path =
  '/api/web/renter/v1/incomeVerification/getVerifiedIncomeReport';

export const CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport = (client = getClient()) => {
  return httpFrontEndRequest<never, never, WebGetIncomeInsightsResponseDto>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeReport_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_Path =
  '/api/web/renter/v1/incomeVerification/getVerifiedIncomeRequestAndReportStatus';

export const CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus = (
  getParams: GetVerifiedIncomeRequestAndReportStatusParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetVerifiedIncomeRequestAndReportStatusParams,
    never,
    WebGetVerifiedIncomeRequestAndReportStatusResponseDto
  >(
    {
      getParams: getParams,
      endpoint: CappsRenterIncomeVerificationWebApiHandler_getVerifiedIncomeRequestAndReportStatus_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterIncomeVerificationWebApiHandler_shareReport_Path =
  '/api/web/renter/v1/incomeVerification/shareReport';

export const CappsRenterIncomeVerificationWebApiHandler_shareReport = (
  postData: ShareReportRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ShareReportRequestDto, void>(
    {
      endpoint: CappsRenterIncomeVerificationWebApiHandler_shareReport_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
